var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Polygon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8247E5",
    d: "M24.17 10.58a2.12 2.12 0 0 0-2 0l-4.67 2.75-3.17 1.75-4.58 2.75c-.58.34-1.33.34-2 0l-3.58-2.16c-.59-.34-1-1-1-1.75V9.75c0-.67.33-1.33 1-1.75l3.58-2.08a2.12 2.12 0 0 1 2 0l3.58 2.16c.59.34 1 1 1 1.75v2.75l3.17-1.83V7.92c0-.67-.33-1.34-1-1.75L9.83 2.25a2.12 2.12 0 0 0-2 0L1 6.25c-.67.33-1 1-1 1.67v7.83c0 .67.33 1.33 1 1.75l6.75 3.92c.58.33 1.33.33 2 0l4.58-2.67 3.17-1.83 4.58-2.67a2.12 2.12 0 0 1 2 0l3.59 2.08c.58.34 1 1 1 1.75v4.17c0 .67-.34 1.33-1 1.75l-3.5 2.08c-.59.34-1.34.34-2 0L18.58 24c-.58-.33-1-1-1-1.75v-2.67l-3.16 1.84v2.75c0 .66.33 1.33 1 1.75l6.75 3.91c.58.34 1.33.34 2 0l6.75-3.91c.58-.34 1-1 1-1.75v-7.92c0-.67-.34-1.33-1-1.75l-6.75-3.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.7ed64c5beb6b91b6a45721f3df36886d.svg";
export { ForwardRef as ReactComponent };